<template>
  <v-app>
    <router-view name="header"></router-view>
<!--    style="background-color: #ebedf0"-->
    <v-content style="background-color: #ebedf0">
      <template v-if="!loading">
        <router-view></router-view>
      </template>
    </v-content>
<!--    <router-view name="footer"></router-view>-->
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {},
  computed: {
    // aguardando carregar o user e entidade antes de renderizar a view
    ...mapGetters('user', ['loading']),
  },
};
</script>
